import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import NavBar from '../../nav-bar/PublicNavBar'
import BunkeyAPI from '../../../api/BunkeyAPI'
import BigFooter from '../../footer/BigFooter'
import { Layout, Skeleton, Icon } from 'antd'
import Post from '../Post'
import './category.css'

const {
  Header, Content
} = Layout

const categories = [
  'dam',
  'marketing',
  'bunkey'
]

class Category extends Component {

  constructor(props) {
    super(props)

    this.state = {
      category: '',
      data: null,
      isFetching: true
    }
  }


  componentDidMount() {
    const { category } = this.props.match.params
    this.handleGetData(category)
  }

  componentDidUpdate(prevProps) {
    const { category } = this.props.match.params
    const { category: prevCategory } = prevProps.match.params
    if (category !== prevCategory) {
      this.setState({
        isFetching: true
      }, () => {
        this.handleGetData(category)
      })
    }
  }

  handleGetData = (category) => {
    if (!categories.find(r => r === category)) this.props.history.push('/')
    const { token } = this.props
    BunkeyAPI({
      url: `/cms/posts/${category}`,
      method: 'POST',
      data: {
        token: token
      },
    }).then(resp => {
      this.setState({
        category,
        data: resp.data,
        isFetching: false
      })
    }).catch(err => {
      this.setState({
        category,
        data: null,
        isFetching: false
      })
    })
  }

  handleGetTitleByCategory() {
    const { category } = this.state
    let result = null
    switch (category) {
      case 'dam':
        result = {
          title: 'DAM´S',
          class: 'category-yellow',
          subtitle: 'Podrás acceder, de forma ordenada y simple, a tus contenidos.'
        }
        break;
      case 'marketing':
        result = {
          title: 'Marketing',
          class: 'category-green',
          subtitle: 'Podrás acceder, de forma ordenada y simple, a tus contenidos.'
        }
        break;
      default:
        result = {
          title: 'Bunkey',
          class: 'category-purple',
          subtitle: 'Somos la llave que abre el potencial de las comunicaciones de la compañía.'
        }
        break;
    }
    return result
  }

  render() {
    const { data, isFetching } = this.state
    const header = this.handleGetTitleByCategory()
    return (
      <Layout>
        <Header className="pub-site-background-color-silver ant-layout-header">
          <NavBar />
        </Header>
        <Content>
          <div className="category-container">
            <Skeleton loading={isFetching} active >
              <div className={header.class}>{data && header.title}</div>
              <div className='category-subtitle'>{data && header.subtitle}</div>
            </Skeleton>
          </div>
          <div style={{ padding: '35px 60px', backgroundColor: '#F4F4F4' }}>
            <div className="masonry-wrapper">
              <div className="masonry">
                {(!data || data.length === 0) && <div><Icon type="loading" /></div>}
                {data && data.length > 0 && data.map((r, k) => {
                  return <Post key={k} object={r} isFetching={isFetching} />
                })}
              </div>
            </div>
          </div>
        </Content>
        <BigFooter />
      </Layout >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.public.token
  }
}

const mapDispatchToProps = {

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Category)))